import React from 'react'
import PropTypes from 'prop-types'
import replace from 'lodash/fp/replace'
import memoize from 'lodash/memoize'

import { OptionsList, OptionItem } from '../Options'

export const getItems = (search, items, getItemText) => items.filter(
  item => !search || getItemText(item).search(search) > -1
)

const memoGetItems = memoize(getItems, (search, items) => JSON.stringify({
  search: search ? search.toString() : '',
  items
}))

export const renderItem = ({
  item,
  index,
  textReplacer,
  highlightedIndex,
  getItemValue,
  getItemText,
  ...props
}) => (
  <OptionItem
    {...props}
    key={getItemValue(item)}
    isHighlighted={index === highlightedIndex}
    dangerouslySetInnerHTML={{ __html: textReplacer(getItemText(item)) }}
  />
)

function AutocompleteMenu({
  isOpen,
  items,
  search,
  highlightedIndex,
  getMenuProps,
  getItemProps,
  getItemValue,
  getItemText
}) {
  if (!isOpen) return null

  const itemTextReplacer = replace(search, '<strong>$&</strong>')

  return (
    <OptionsList {...getMenuProps({ refKey: 'ref' })}>
      {memoGetItems(search, items, getItemText)
        .map((item, index) => renderItem({
          ...getItemProps({ item }),
          item,
          index,
          textReplacer: itemTextReplacer,
          highlightedIndex,
          getItemValue,
          getItemText
        }))}
    </OptionsList>
  )
}

const sharedPropTypes = {
  highlightedIndex: PropTypes.number,
  getItemProps: PropTypes.func.isRequired,
  getItemValue: PropTypes.func.isRequired,
  getItemText: PropTypes.func.isRequired
}

renderItem.propTypes = {
  ...sharedPropTypes,
  item: PropTypes.any.isRequired,
  index: PropTypes.number.isRequired,
  textReplacer: PropTypes.func.isRequired
}

AutocompleteMenu.propTypes = {
  ...sharedPropTypes,
  search: PropTypes.instanceOf(RegExp),
  isOpen: PropTypes.bool.isRequired,
  items: PropTypes.array.isRequired,
  getMenuProps: PropTypes.func.isRequired
}

export default AutocompleteMenu
